import { AlertSeverity, AlertSortBy, BreachedRuleSummary } from './component-sidebar.types';

const stateWeightMap: Record<AlertSeverity, number> = {
  [AlertSeverity.Normal]: 0,
  [AlertSeverity.Minor]: 1,
  [AlertSeverity.Medium]: 2,
  [AlertSeverity.High]: 3,
};

export class ComponentSidebarSorterService {
  constructor() {}

  sortBreaches(sortBy: AlertSortBy, breaches: BreachedRuleSummary[], ruleBk: string | undefined): BreachedRuleSummary[] {
    switch (sortBy) {
      case AlertSortBy.Severity:
        return this.sortByHighestSeverity([...breaches]);
      case AlertSortBy.BreachStatus:
        return this.sortByIsOngoing([...breaches]);
      case AlertSortBy.LastBreach:
        return this.sortByLastBreach([...breaches]);
      case AlertSortBy.RuleBk:
        return this.sortByRuleBk([...breaches], ruleBk ?? undefined);
    }
  }

  private sortByHighestSeverity(items: BreachedRuleSummary[]): BreachedRuleSummary[] {
    return items.sort((a, b) => this.mapStateToWeight(b.highestSeverity) - this.mapStateToWeight(a.highestSeverity));
  }

  private sortByIsOngoing(items: BreachedRuleSummary[]): BreachedRuleSummary[] {
    return items.sort((a, b) => (a.isOngoing === b.isOngoing ? 0 : a.isOngoing ? -1 : 1));
  }

  private sortByLastBreach(items: BreachedRuleSummary[]): BreachedRuleSummary[] {
    return items.sort((a, b) => new Date(b.lastBreach).getTime() - new Date(a.lastBreach).getTime());
  }

  private sortByRuleBk(items: BreachedRuleSummary[], ruleBk?: string): BreachedRuleSummary[] {
    return items.sort((a, b) => {
      if (a.ruleBk === ruleBk && b.ruleBk !== ruleBk) return -1;
      if (b.ruleBk === ruleBk && a.ruleBk !== ruleBk) return 1;
      return this.mapStateToWeight(b.highestSeverity) - this.mapStateToWeight(a.highestSeverity);
    });
  }

  private mapStateToWeight(state: AlertSeverity): number {
    return stateWeightMap[state];
  }
}
